<template>

<div>
    <div>
    <input type="text" :value="value" v-on:input="$emit('input', $event)">
        </div>
</div>

</template>

<script>
// import IonSlider from "../elements/IonSlider";

export default {
    name: "live-element",
    props: [ 'value'],
    // components: {IonSlider},
    // data: function (){
    //     return {
    //         vvv: '',
    //     }
    // }
}
</script>

<style scoped>

</style>
